import React, { useMemo } from "react";
import CommonTable, { createRowCellContentInner } from "../../../common/table";
import { RequestHistory } from "../../../../types/brm/request-types";
import { Column, TableFilterData } from "../../../../types/common/table/table-types";
import { useIntl } from "react-intl";

type RequestDetailedHistoryTabProps = {
    requestHistory: RequestHistory[];
    filterData: TableFilterData[];
    setFilterData: (value: TableFilterData) => void;
    getDialogFilters: (params: { field: string; search?: string }) => Promise<{ rows: { key: string; text: string }[]; total: number }>;
    total: number;
    pageNumber: number;
    limitNumber: number;
    setPageNumber: (pageNumber: number) => void;
    setLimitNumber: (limitNumber: number) => void;
};

const createRowCellContent = (
    row: RequestHistory,
    column: Column,
    selected: boolean,
    onSelect: (id: string) => void,
    getCellValue: (row: Request, column: Column) => string
): JSX.Element => {
    switch (column.id) {
        default:
            return createRowCellContentInner(row, column, selected, onSelect, getCellValue);
    }
};

const getCellValue = (row: RequestHistory, column: Column) => {
    switch (column.id) {
        default:
            return row[column.id];
    }
};

const getTableRowId = (row: RequestHistory) => row.id;

const RequestDetailedHistoryTab: React.FC<RequestDetailedHistoryTabProps> = ({
    filterData,
    setFilterData,
    getDialogFilters,
    requestHistory,
    total,
    pageNumber,
    limitNumber,
    setLimitNumber,
    setPageNumber,
}) => {
    const intl = useIntl();
    const toolbarActions = [];

    const columns = useMemo(
        () => [
            {
                id: "operation",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.operation" }),
                type: "string",
                width: "500px",
                sortable: false,
                filterable: true,
            },
            {
                id: "status",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.status" }),
                type: "string",
                sortable: false,
                filterable: true,
            },
            {
                id: "authorText",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.author-text" }),
                type: "string",
                sortable: false,
                filterable: true,
            },
            {
                id: "createdAt",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.created-at" }),
                type: "datetime",
                sortable: false,
                filterable: true,
            },
            {
                id: "newValue",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.new-value" }),
                type: "string",
                sortable: false,
                filterable: true,
            },
            {
                id: "oldValue",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.old-value" }),
                type: "string",
                sortable: false,
                filterable: true,
            },
            {
                id: "additionalInfo",
                title: intl.formatMessage({ id: "request-detailed-history-table-column.additional-info" }),
                type: "string",
                sortable: false,
                filterable: true,
            },
        ],
        [intl]
    );
    return (
        <>
            <CommonTable
                rows={requestHistory}
                columns={columns}
                toolbarActions={toolbarActions}
                getRowId={getTableRowId}
                getCellValue={getCellValue}
                useKeyboardNavigation={false}
                toolbar={[]}
                showFiltersActions={false}
                createRowCellContent={createRowCellContent}
                setFilterData={setFilterData}
                getFilters={getDialogFilters}
                filterData={filterData}
                total={total}
                limitNumber={limitNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                setLimitNumber={setLimitNumber}
            />
        </>
    );
};

export default RequestDetailedHistoryTab;
